import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'
import SaveButton from '../../component/buttons/SaveButton';
import Number from '../../component/input_filed/Number';
import MultiSelect from '../../component/input_filed/MultiSelect';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { defectListTodo } from '../../redux/slices/master/defects/DefectList';
import Loader from '../../component/loader/Loader';
import AddButton from '../../component/buttons/AddButton';
import { useFormik } from 'formik';
import { updateConfigurationTodo } from '../../redux/slices/tooling-configuration/UpdateConfiguration';
import { toast, ToastContainer } from 'react-toastify';
import { configurationSchema } from './ValidationSchema';
import { configurationListTodo } from '../../redux/slices/tooling-configuration/ConfigurationList';

export default function ConfigurationForm() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [spiner, setSpiner] = useState(false)
    const defectList = useSelector(state => state?.defectList?.data?.data)
    const configuration = useSelector(state => state?.configurationList?.data?.data?.[0])

    const defect_option = defectList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    let defect_item = [];
    try {
        defect_item = configuration?.defect && configuration.defect !== "undefined"
            ? JSON.parse(configuration.defect)
            : [];
    } catch (e) {
        defect_item = [];
    }

    const initiaValues = {
        min_edge_trim: configuration?.min_edge || '',
        max_edge_trim: configuration?.max_edge || '',
        min_good_piece_length: configuration?.min_good_piece_length || '',
        min_final_length: configuration?.min_final_length || '',
        max_welds_per_coil: configuration?.max_welds || '',
        defect_item: defect_item || []
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: configurationSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(updateConfigurationTodo(values)).then((res) => update_res(res))

        }
    })

    const update_res = (res) => {
        if (res?.payload?.status == 200) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/user-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    useEffect(() => {
        setLoading(true)
        Promise.all([
            dispatch(defectListTodo({ navigate })),
            dispatch(configurationListTodo({ navigate })),
        ]).finally(() => setLoading(false));
    }, [bool])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="main_layout">
                            <div className=' d-flex justify-content-between align-items-center mb-3'>
                                <h5>Tooling Configuration</h5>
                                <Link to='/tooling-configuration-history'>   <AddButton label={"HISTORY"} /> </Link>
                            </div>
                            <hr />
                            {loading ?
                                <div>
                                    <Loader />
                                </div> :
                                <Form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-4">

                                            <Number
                                                label_name='Min Edge Trim (mm)'
                                                name='min_edge_trim'
                                                value={values.min_edge_trim}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.min_edge_trim && touched.min_edge_trim && <span className='text-danger form_label'>{errors.min_edge_trim}</span>}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Number
                                                label_name='Max Edge Trim (mm)'
                                                name='max_edge_trim'
                                                value={values.max_edge_trim}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.max_edge_trim && touched.max_edge_trim && <span className='text-danger form_label'>{errors.max_edge_trim}</span>}
                                            />

                                        </div>
                                        <div className="col-md-4">
                                            <Number
                                                label_name='Min Good Piece Length (m)'
                                                name='min_good_piece_length'
                                                value={values.min_good_piece_length}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.min_good_piece_length && touched.min_good_piece_length && <span className='text-danger form_label'>{errors.min_good_piece_length}</span>}
                                            />

                                        </div>

                                        <div className="col-md-4">
                                            <Number
                                                label_name='Min Final Length (m)'
                                                name='min_final_length'
                                                value={values.min_final_length}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.min_final_length && touched.min_final_length && <span className='text-danger form_label'>{errors.min_final_length}</span>}
                                            />

                                        </div>
                                        <div className="col-md-4">
                                            <Number
                                                label_name='Max  Welds per Coil(as per min final length)'
                                                name='max_welds_per_coil'
                                                value={values.max_welds_per_coil}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.max_welds_per_coil && touched.max_welds_per_coil && <span className='text-danger form_label'>{errors.max_welds_per_coil}</span>}
                                            />

                                        </div>
                                        <div className="col-md-4">

                                            <MultiSelect
                                                label_name='Defect'
                                                option={defect_option}
                                                closeMenu={false}
                                                name='defect_item'
                                                value={values.defect_item}
                                                onChange={(e) => setFieldValue('defect_item', e)}
                                                onBlur={handleBlur}
                                                error={errors.defect_item && touched.defect_item && <span className='text-danger form_label'>{errors.defect_item}</span>}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <div xl='12' className='d-flex justify-content-end'>
                                                <SaveButton name={'  UPDATE  '} spiner={spiner} />
                                            </div>
                                        </div>
                                    </div>
                                </Form>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
